import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Coins, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { NextRewardProgress } from "@/components/TodayForYou";

export default function PointsGuide() {
  const [g, setG] = useState(null);
  const [nr, setNr] = useState(null);
  useEffect(() => {
    api.get("/points-guide").then(({ data }) => setG(data)).catch(() => setG([]));
    api.get("/next-reward").then(({ data }) => setNr(data)).catch(() => {});
  }, []);
  return (
    <div className="max-w-2xl mx-auto space-y-6 pb-20" data-testid="points-guide-page">
      <div className="flex items-center gap-3">
        <span className="w-11 h-11 rounded-2xl pink-gradient flex items-center justify-center"><Coins className="w-6 h-6 text-white" /></span>
        <div><h1 className="font-display text-2xl sm:text-3xl font-extrabold">So sammelst du Punkte</h1><p className="text-sm text-slate-500">Alle Wege auf einen Blick – und dann gegen tolle Prämien eintauschen.</p></div>
      </div>
      {nr && <NextRewardProgress next={nr.next} points={nr.points} />}
      {!g ? <Loader2 className="w-6 h-6 animate-spin text-rose-300 mx-auto" /> : g.map((grp) => (
        <section key={grp.group} className="space-y-2" data-testid={`points-guide-${grp.group}`}>
          <h2 className="text-xs font-extrabold uppercase tracking-[0.2em] text-rose-500">{grp.group}</h2>
          <ul className="rounded-3xl bg-white border border-pink-100 divide-y divide-pink-50 overflow-hidden">
            {grp.items.map((it) => (
              <li key={it.label}><Link to={it.url} className="flex items-center gap-3 px-4 py-3 hover:bg-rose-50/50 transition-colors">
                <span className="flex-1 text-sm font-semibold">{it.label}</span>
                <span className="text-sm font-extrabold text-rose-600 whitespace-nowrap">{it.points != null ? `+${it.points}` : "Punkte & Preise"}</span>
                <ChevronRight className="w-4 h-4 text-slate-300" />
              </Link></li>
            ))}
          </ul>
        </section>
      ))}
      <Link to="/geschenke" data-testid="points-guide-rewards" className="block text-center h-12 leading-[3rem] rounded-full pink-gradient text-white font-bold">Zu den Prämien</Link>
    </div>
  );
}
